import { render, staticRenderFns } from "./AskSubModal.vue?vue&type=template&id=8c3bbcb4&scoped=true&"
import script from "./AskSubModal.vue?vue&type=script&lang=js&"
export * from "./AskSubModal.vue?vue&type=script&lang=js&"
import style0 from "./AskSubModal.vue?vue&type=style&index=0&id=8c3bbcb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3bbcb4",
  null
  
)

export default component.exports